var React = require('react');

function Gift (props) {
    return React.createElement("svg",props,[React.createElement("polyline",{"points":"20 12 20 22 4 22 4 12","key":0}),React.createElement("rect",{"x":"2","y":"7","width":"20","height":"5","key":1}),React.createElement("line",{"x1":"12","y1":"22","x2":"12","y2":"7","key":2}),React.createElement("path",{"d":"M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z","key":3}),React.createElement("path",{"d":"M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z","key":4})]);
}

Gift.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","className":"feather feather-gift"};

module.exports = Gift;

Gift.default = Gift;
